import { useCallback, useMemo } from 'react';

import { AnalyticsEvent } from '../../../../constants/AnalyticsEvent';
import ElementType from '../../../../constants/ElementType';
import { MktType } from '../../../../constants/MktType';
import withDisplayImpression from '../../../../decorators/withDisplayImpression';
import { ItemTypes, WebLinkOpenType } from '../../../../types/Common';
import * as navigationService from '../../../../utils/navigationService';
import { usePriceText, useReduxHooks, useWebHref } from './hooks';
import S from './styles';

interface Props {
  id: string;
  index: number;
  layoutName: string;
  source?: string;
}

export function ListItem(props: Props) {
  const { id, index, source, layoutName } = props;
  const { logEvent, item } = useReduxHooks({ id });

  const { title, image_url, original_min_price, min_price } = item;

  const { originPriceText, currentPriceText } = usePriceText(
    min_price,
    original_min_price
  );

  const href = useWebHref({ id });

  const handleItemPressed = useCallback(() => {
    logEvent({
      logEvent: AnalyticsEvent.Click,
      data: {
        id,
        itemType: ItemTypes.USER_SUBMIT,
        pitNumber: index + 1,
        layoutName,
        source,
        mktType: MktType.Image,
        elementType: ElementType.Item,
        title,
      },
    });

    navigationService.navigate('ItemPage', {
      id,
    });
  }, [id, title, index, source, layoutName, logEvent]);

  const imageSource = useMemo(() => ({ uri: image_url }), [image_url]);

  return (
    <S.Touchable
      accessibilityRole="link"
      target={WebLinkOpenType.SELF}
      href={href}
      onPress={handleItemPressed}
    >
      <S.Container>
        <S.Image source={imageSource} />
        <S.OriginalPrice>{originPriceText}</S.OriginalPrice>
        <S.CurrentPriceWrapper>
          <S.DiscountIcon source={require('./assets/ic_discount.png')} />
          <S.CurrentPrice>{currentPriceText}</S.CurrentPrice>
        </S.CurrentPriceWrapper>
      </S.Container>
    </S.Touchable>
  );
}

export default withDisplayImpression(ListItem);
